import { useDispatch } from "react-redux";
import {
  setUserEdit,
  setUserStatus,
  userSuccess,
} from "../../Reducer/UserReducer";
import axios from "axios";
import HoldOn from "react-hold-on";
import apiUrl from "../../ApiUrl";

export const getUserDetail = (studentId) => async (dispatch) => {
  let options = {
    theme: "sk-cube-grid",
    message: "Fetching user details...",
  };

  try {
    HoldOn.open(options);

    const headers = {
      "user-id": studentId,
      redirect: "follow",
    };

    const response = await axios.get(`${apiUrl}users/fetch/id`, { headers });

    if (response.data) {
      console.log("User Details:", response.data);
      const { status, edit } = response.data;
      console.log("status", status);
      console.log("editing", edit);
      dispatch(userSuccess(response.data));
      dispatch(setUserStatus(status));
      dispatch(setUserEdit(edit));
      return response.data;
    }
  } catch (error) {
    console.error("Error in getUserDetail api:", error);
    throw error;
  } finally {
    HoldOn.close();
    console.log("user detail finally call");
  }
};
